import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function SurvivorGraph({ eliminated, short, survivors, total }) {
  var survivorsPct = Math.round(survivors / total * 100.0);
  var eliminatedPct = Math.round(eliminated / total * 100.0);
  var remainderPct = Math.round(100 - survivorsPct - eliminatedPct);

  var eliminatedBar;
  var remainderBar;
  if (eliminated > 0) {
    eliminatedBar = (
      <li className="survivor-stats_cell survivor-stats_cell--eliminated" style={{ width: eliminatedPct + "%" }}>
        {eliminated}
      </li>
    );
  }
  if (remainderPct > 0) {
    remainderBar = <li className="survivor-stats_cell" style={{ width: remainderPct + "%" }} />;
  }
  return (
    <ul className={classes({
      "survivor-stats_graph": true,
      "survivor-stats_graph--short": short
    })}>
      <li className="survivor-stats_cell survivor-stats_cell--winner" style={{ width: survivorsPct + "%" }}>
        {survivors}
      </li>

      {eliminatedBar}

      {remainderBar}
    </ul>
  );
});
